<template>
  <div v-if="$canRoute('create-new-user-account') ===1" class="trade-dropdown">
    <v-menu rounded="0" class="trade-dropdown-menu" transition="slide-x-transition" bottom left>
      <template v-slot:activator="{ attrs, on }">
        <v-btn small tile elevation="0" class="ma-0 text-capitalize btn-account" v-bind="attrs" v-on="on" icon>
          <v-icon :color="$vuetify.theme.dark ? '#fff' : '#162334'">mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-card class="dropdown-menu-card" tile flat>
        <v-list flat outlined :color="$vuetify.theme.dark ? '#111A26' : '#F1F7FB'">
          <v-list-item-group>
            <!-- <v-list-item :ripple="false" link>
              <v-list-item-content>
                <router-link class="text-decoration-none" to="/">Add New Live Account</router-link>
              </v-list-item-content>
            </v-list-item>
            <v-list-item :ripple="false" link>
              <v-list-item-content>
                <router-link class="text-decoration-none" to="/">Add New Demo Account</router-link>
              </v-list-item-content>
            </v-list-item>
            <v-list-item :ripple="false">
              <v-list-item-content>
                <ChangeAccountModal></ChangeAccountModal>
              </v-list-item-content>
            </v-list-item>
            <v-list-item :ripple="false">
              <v-list-item-content>
                <DepositFundsModal></DepositFundsModal>
              </v-list-item-content>
            </v-list-item>
            <v-list-item :ripple="false">
              <v-list-item-content>
                <WithdrawFundsModal></WithdrawFundsModal>
              </v-list-item-content>
            </v-list-item>
            <v-list-item :ripple="false">
              <v-list-item-content>
                <InternalTransferModal></InternalTransferModal>
              </v-list-item-content>
            </v-list-item>
            <v-list-item :ripple="false">
              <v-list-item-content>
                <CreditInOutModal></CreditInOutModal>
              </v-list-item-content>
            </v-list-item> -->
            <v-list-item :ripple="false">
              <v-list-item-content>
                <ChangePasswordModal></ChangePasswordModal>
              </v-list-item-content>
            </v-list-item>
            <!-- <v-list-item :ripple="false">
              <v-list-item-content>
                <Mt5PasswordModal></Mt5PasswordModal>
              </v-list-item-content>
            </v-list-item>
            <v-list-item :ripple="false">
              <v-list-item-content>
                <ChangeLeverageModal></ChangeLeverageModal>
              </v-list-item-content>
            </v-list-item> -->
            <v-list-item :ripple="false">
              <v-list-item-content>
                <UpdateBlockUserModal></UpdateBlockUserModal>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import ChangeAccountModal from './ChangeAccountModal.vue';
import UpdateBlockUserModal from './UpdateBlockUserModal.vue';
import ChangeLeverageModal from './ChangeLeverageModal.vue';
import ChangePasswordModal from './ChangePasswordModal.vue';
import CreditInOutModal from './CreditInOutModal.vue';
import DepositFundsModal from './DepositFundsModal.vue';
import InternalTransferModal from './InternalTransferModal.vue';
import Mt5PasswordModal from './Mt5PasswordModal.vue';
import WithdrawFundsModal from './WithdrawFundsModal.vue';
import {  mapState } from "vuex";

export default {
  components: { ChangeAccountModal, DepositFundsModal, WithdrawFundsModal, InternalTransferModal, CreditInOutModal, ChangePasswordModal, Mt5PasswordModal, ChangeLeverageModal, UpdateBlockUserModal },
  computed: {
    ...mapState("admins", ["loggedAdmin"]),
  },
  methods: {},

};
</script>

<style></style>